/** Rota da LP de simulador (mesmas âncoras de seção da home). */
export const SIMULATOR_LANDING_PATH = "/simular" as const

export function isSimulatorLandingPath(pathname: string | null | undefined): boolean {
  return pathname === SIMULATOR_LANDING_PATH
}
